module.exports = __webpack_public_path__ + "img/bkl7.b316e011.jpg";